export default __webpack_public_path__ + "images/piechart.5a2ba7a5f7cb8545cc85ccf1cfb00a1a.svg";